import { useEffect, useState } from 'react'
import { Modal } from '../ui/modal'
import { LEGAL_TERMS_VERSION } from '../../constants/legal'
import {
  LEGAL_DOCS,
  LEGAL_DOC_TABS,
  type LegalDocKey,
} from '../../constants/legalContent'
interface Props {
  open: boolean
  onClose: () => void
  initialDocKey?: LegalDocKey
  legalTermsVersion?: string
}
export default function LegalTermsModal({
  open,
  onClose,
  initialDocKey = 'userAgreement',
  legalTermsVersion,
}: Props) {
  const [active, setActive] = useState<LegalDocKey>(initialDocKey)
  useEffect(() => {
    if (open) setActive(initialDocKey)
  }, [open, initialDocKey])
  const doc = LEGAL_DOCS[active]
  return (
    <Modal
      open={open}
      onOpenChange={(value) => {
        if (!value) onClose()
      }}
      title="法律條款"
      className="max-w-4xl"
    >
      <div
        role="tablist"
        aria-label="法律文件"
        className="mb-5 flex flex-wrap gap-2 border-b pb-3"
      >
        {LEGAL_DOC_TABS.map((tab) => (
          <button
            type="button"
            key={tab.key}
            role="tab"
            id={`legal-tab-${tab.key}`}
            aria-selected={active === tab.key}
            aria-controls="legal-document-panel"
            className={`rounded-lg px-3 py-2 text-sm ${active === tab.key ? 'bg-primary text-white' : 'bg-muted text-muted-foreground'}`}
            onClick={() => setActive(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <article
        role="tabpanel"
        id="legal-document-panel"
        aria-labelledby={`legal-tab-${active}`}
        className="max-h-[62vh] overflow-y-auto pr-2 text-sm leading-relaxed"
      >
        <h2 className="mb-2 text-xl font-semibold">{doc.pageTitle}</h2>
        <p className="text-muted-foreground">
          版本：{legalTermsVersion || LEGAL_TERMS_VERSION}
          <br />
          生效日期：{doc.effectiveDate}
        </p>
        <div className="mt-5 space-y-5">
          {doc.sections.map((section) => (
            <section key={section.title}>
              <h3 className="mb-2 font-semibold">{section.title}</h3>
              {section.paragraphs.map((text, index) => (
                <p key={index} className="mb-2">
                  {text}
                </p>
              ))}
            </section>
          ))}
        </div>
        <p className="text-muted-foreground">
          如有疑問，請聯絡：admin@kyren.io
        </p>
      </article>
    </Modal>
  )
}
